import styled from 'styled-components'
import { ReactComponent as ArrowIcon } from '@sketch/icons/circle-arrow-up-left-semifilled-17'
import { LinkButton } from '@sketch/components'

export const StyledLeftArrow = styled(ArrowIcon)`
  width: 17px;
  color: ${({ theme }) => theme.colors.foreground.secondary.D};
`

export const StyledButton = styled(LinkButton).attrs({
  variant: 'tertiary',
  size: '32',
})`
  width: 32px;
  height: 32px;
  background-color: transparent;

  &:hover,
  &:active {
    background-color: transparent;
  }
`
